import React from "react";

import { CButton } from "@coreui/react";
import { useHttp } from "../hooks/useHttp";
import { useMutation } from "@tanstack/react-query";

import Popup from "../components/Popup";
import openToast from "../utils/sweetAlert";

const PopupCustomerEmail = props => {
  const { trigger, setTrigger, chat } = props;

  const request = useHttp();

  const contactMutation = useMutation(["send-contact"], () => request({ url: `/users/send/contact/${chat.user_id}`, method: "POST", data: {} }), {
    onSuccess: res => {
      if (res.data.error) {
        openToast("error", "Ocorreu um erro", res.data.message);
      }

      if (!res.data.error) {
        openToast("success", "Sucesso", res.data.message);
        setTrigger(false);
      }
    }
  });

  return (
    <Popup title="Enviar e-mail para o cliente" trigger={trigger} setTrigger={setTrigger} width="420">
      <div className="x-p-20">
        <div className="text-color mt-10">
          Tem certeza que deseja enviar um e-mail para o cliente atual?
        </div>

        <div className="d-flex flex-row justify-content-between mt-20 mb-20">
          <div></div>
          <div>
            <CButton color="danger" variant="ghost" onClick={() => setTrigger(false)}>Cancelar</CButton>
            <CButton type="submit" color="primary" className="ml-10" onClick={() => contactMutation.mutate()}>
              {contactMutation.isLoading ? "Enviando..." : "Sim, enviar"}
            </CButton>
          </div>
        </div>
      </div>
    </Popup>
  );
}

export default PopupCustomerEmail;